import { WrapPageElementNodeArgs } from 'gatsby';

import { StyleOverride } from '@src/branding/base/override';

export const wrapPageElement = ({ element, props }: WrapPageElementNodeArgs) => {
  return <StyleOverride {...props}>{element}</StyleOverride>;
};
